
var swiper = new Swiper(".product-gallery-thumbsnail-wrapper", {
  spaceBetween: 10,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,

  breakpoints: {
    0: {
      direction: "horizontal",
      slidesPerView: 4
    },
    992: {
      direction: "vertical",
      slidesPerView: 4
    }
  }
});

var swiper2 = new Swiper(".product-gallery-main-image-wrapper", {
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});








if (!customElements.get("custom-details")) {
  customElements.define(
    "custom-details",
    class CustomDetails extends HTMLElement {
      constructor() {
        super();

        this.item = this;
        this.toggle = this.querySelector(".faq-item-title");
        this.panel = this.querySelector(".faq-item-content");

        this.init();
      }

      init() {
        if (!this.toggle || !this.panel) return;

        this.toggle.addEventListener("click", () => {
          if (this.classList.contains("is-open")) {
            this.close();
          } else {
            this.closeOthers();
            this.open();
          }
        });
      }

      open() {
        this.classList.add("is-open");

        this.panel.style.height = "0px";

        requestAnimationFrame(() => {
          this.panel.style.height = this.panel.scrollHeight + "px";
        });
      }

      close() {
        this.panel.style.height = this.panel.scrollHeight + "px";
        this.classList.remove("is-open");

        requestAnimationFrame(() => {
          this.panel.style.height = "0px";
        });
      }

      closeOthers() {
        document.querySelectorAll("custom-details.is-open").forEach((item) => {
          if (item !== this) {
            const panel = item.querySelector(".faq-item-content");

            panel.style.height = panel.scrollHeight + "px";
            item.classList.remove("is-open");

            requestAnimationFrame(() => {
              panel.style.height = "0px";
            });
          }
        });
      }
    }
  );
}